import { useState } from 'react'
import { Radio } from '@/components/commons/radio'
import { SubmissionFooter } from '@/features/luxe-submissions/components/submission-footer'
import { SubmissionFormHeader } from '@/features/luxe-submissions/components/submission-form-header'
import type { ListingType } from '@/features/luxe-submissions/types'
import { routes } from '@/routes'
import { useTranslation } from '@/translations/i18n'

function LuxeSubmissionsSubmission() {
	const { t } = useTranslation()
	const [listingType, setListingType] = useState<ListingType | undefined>()

	const getNextPath = () => {
		if (listingType === 'airbnb') {
			return routes.LUXE_SUBMISSIONS_SUBMISSION_LISTING.handle.fullPath
		}
		if (listingType === 'other') {
			return routes.LUXE_SUBMISSIONS_SUBMISSION_OTHER.handle.fullPath
		}
		return ''
	}

	return (
		<div className='flex flex-1 flex-col bg-neutral-white'>
			<SubmissionFormHeader />

			<div className='flex flex-1 flex-col'>
				<div className='m:m-6 flex flex-col gap-6 m:rounded-3xl m:border m:border-neutral-300 m:p-6 px-6 py-4'>
					<h2 className='font-bold text-grey-750 text-lg'>
						{t('luxe_submissions:listing_type')}
					</h2>

					<div className='flex flex-col gap-6'>
						<Radio
							checked={listingType === 'airbnb'}
							label={
								<div className='flex flex-col gap-0.5'>
									<span className='text-neutral-900'>
										{t('luxe_submissions:airbnb_listing')}
									</span>
									<span className='text-neutral-600 text-sm'>
										{t(
											'luxe_submissions:airbnb_listing_description'
										)}
									</span>
								</div>
							}
							name='listingType'
							onChange={() => setListingType('airbnb')}
							value='airbnb'
							variant='brand'
						/>

						<Radio
							checked={listingType === 'other'}
							label={
								<div className='flex flex-col gap-0.5'>
									<span className='text-neutral-900'>
										{t('luxe_submissions:other_listing')}
									</span>
									<span className='text-neutral-600 text-sm'>
										{t(
											'luxe_submissions:other_listing_description'
										)}
									</span>
								</div>
							}
							name='listingType'
							onChange={() => setListingType('other')}
							value='other'
							variant='brand'
						/>
					</div>
				</div>
			</div>

			<SubmissionFooter
				disabled={!listingType}
				label={t('luxe_submissions:next')}
				to={getNextPath()}
			/>
		</div>
	)
}

export { LuxeSubmissionsSubmission }
